import {BasketAction} from "../actions/basket.actions";
import {initialState} from "../reducers/root.reducer";
import {Basket} from "../../models/basket.model";
import {BasketActionTypes} from "../actions/types";

export const basketReducer = (
  state: Basket = initialState.basket,
  action: BasketAction
) => {
  switch (action.type) {
    case BasketActionTypes.ADD_TO_BASKET:
      return action.payload;
    case BasketActionTypes.REMOVE_FROM_BASKET:
      return action.payload;
    case BasketActionTypes.UPDATE_BASKET:
      return action.payload;
    case BasketActionTypes.CLEAR_BASKET:
     // console.log("clearing basket")
      return new Basket();
    default:
      return state;
  }
};
